export default "__VITE_ASSET__BQka3UBv__"